import React from 'react';
import { Button, withStyles, Chip } from '@material-ui/core';
import { Refresh, Home } from '@material-ui/icons';
import appConstants from '../../../appConstants';
import AnimationRenderer from '../../../components/animations/animationRenderer';
import * as RMAXErrorAnimation from '../../../components/animations/json/RMAXErrorAnimation.json';
import { categorizeError, getErrorCategoryDisplayName } from '../../utils/errorUtils';
import ErrorDetailsSection from '../common/ErrorDetailsSection';
import styles from './styles';
class RootErrorFallback extends React.Component {
  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { classes, error, errorInfo, errorId } = this.props;
    const errorCategory = categorizeError(error);

    return (
      <div className={classes.errorContainer}>
        <div className={classes.errorContent}>
          <div className={classes.contentWrapper}>
            <div className={classes.animationContainer}>
              <AnimationRenderer dimension={600} animationJSON={RMAXErrorAnimation} />
            </div>
            <div className={classes.textContainer}>
              <div className={classes.errorTitle}>Something went wrong</div>

              <div className={classes.errorCategory}>
                <Chip
                  label={getErrorCategoryDisplayName(errorCategory)}
                  className={classes.categoryChip}
                  size="small"
                />
              </div>
              <div className={classes.errorDescription}>
                We encountered an unexpected error. Please try refreshing the page or contact
                support if the problem persists.
              </div>
              <ErrorDetailsSection
                classes={classes}
                error={error}
                errorInfo={errorInfo}
                errorId={errorId}
                reportType="Error Report"
              />
              <div className={classes.buttonContainer}>
                <Button
                  color="primary"
                  variant="contained"
                  classes={{ root: classes.button }}
                  onClick={this.handleReload}>
                  <div className={classes.linkContent}>
                    <Refresh className={classes.icon} />
                    Reload Page
                  </div>
                </Button>

                <Button
                  color="primary"
                  variant="outlined"
                  classes={{ root: classes.secondaryButton }}
                  onClick={() => {
                    window.location.href = appConstants.NAV_URLS.IBPLANNING_HOME;
                  }}>
                  <div className={classes.linkContent}>
                    <Home className={classes.icon} />
                    Go Home
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(RootErrorFallback);
